module.exports = __webpack_public_path__ + "img/20231009161509265i7b.57c70671.jpg";